


import { SvgIcon, SvgIconProps } from "@mui/material";

interface CloseIconProps extends SvgIconProps {
    fillColorPath?: string
}
const CloseIcon = ({ fillColorPath = "#A4A4A4", ...props }: CloseIconProps) => {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M18.3007 5.71022C17.9107 5.32022 17.2807 5.32022 16.8907 5.71022L12.0007 10.5902L7.1107 5.70021C6.7207 5.31021 6.0907 5.31021 5.7007 5.70021C5.3107 6.09021 5.3107 6.72022 5.7007 7.11022L10.5907 12.0002L5.7007 16.8902C5.3107 17.2802 5.3107 17.9102 5.7007 18.3002C6.0907 18.6902 6.7207 18.6902 7.1107 18.3002L12.0007 13.4102L16.8907 18.3002C17.2807 18.6902 17.9107 18.6902 18.3007 18.3002C18.6907 17.9102 18.6907 17.2802 18.3007 16.8902L13.4107 12.0002L18.3007 7.11022C18.6807 6.73022 18.6807 6.09022 18.3007 5.71022Z" fill={fillColorPath} />
        </SvgIcon>
    )



}


export default CloseIcon;